var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default panel-enodo selected"},[_c('div',{staticClass:"panel-heading text-uppercase"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }